import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import WorklogReport from "./views/reports/worklog/WorklogReport.vue";
import Employees from "./views/catalogs/employees/Employees.vue";
import Employee from "./views/catalogs/employees/Employee.vue";
import Users from "./views/system/users/Users.vue";
import User from "./views/system/users/User.vue";
import Clients from "./views/catalogs/clients/Clients.vue";
import Client from "./views/catalogs/clients/Client.vue";
import Managers from "./views/catalogs/managers/Managers.vue";
import Manager from "./views/catalogs/managers/Manager.vue";
import PaymentPackages from "./views/catalogs/payment-packages/PaymentPackages.vue";
import PaymentPackage from "./views/catalogs/payment-packages/PaymentPackage.vue";
import Services from "./views/catalogs/services/Services.vue";
import Service from "./views/catalogs/services/Service.vue";
import Products from "./views/catalogs/products/Products.vue";
import Product from "./views/catalogs/products/Product.vue";
import Payments from "./views/operations/payments/Payments.vue";
import Payment from "./views/operations/payments/Payment.vue";
import Bonuses from "./views/operations/bonus/Bonuses.vue";
import Bonus from "./views/operations/bonus/Bonus.vue";
import Invoices from "./views/operations/invoices/Invoices.vue";
import Invoice from "./views/operations/invoices/Invoice.vue";
import Balance from "./views/reports/balance/Balance.vue";
import Debt from "./views/reports/debt/Debt.vue";
import Projects from "./views/catalogs/projects/Projects.vue";
import Project from "./views/catalogs/projects/Project.vue";
import ServiceTypes from "./views/catalogs/service-types/ServiceTypes.vue";
import ServiceType from "./views/catalogs/service-types/ServiceType.vue";
import ServicesToProlongation from "./views/reports/services-to-prolongation/ServicesToProlongation.vue";
import PackagesToProlongation from "./views/reports/packages-to-prolongation/PackagesToProlongation.vue";
import PackagesToProlongationOld from "./views/reports/packages-to-prolongation/PackagesToProlongationOld.vue";
import PaymentSources from "./views/catalogs/payment-sources/PaymentSources.vue";
import PaymentSource from "./views/catalogs/payment-sources/PaymentSource.vue";
import Payers from "./views/catalogs/payers/Payers.vue";
import Payer from "./views/catalogs/payers/Payer.vue";
import ProductCategories from "./views/catalogs/product-categories/ProductCategories.vue";
import ProductCategory from "./views/catalogs/product-categories/ProductCategory.vue";
import SalesByPayments from "./views/reports/sales-by-payments/SalesByPayments.vue";
import ManagersBonuses from "./views/reports/managers-bonuses/ManagersBonuses.vue";
import WorklogSummary from "./views/reports/worklog-summary/WorklogSummary.vue";
import Privat24 from "@/views/integration/privat24/Transactions.vue";
import Taskombank from "@/views/integration/taskombank/Transactions.vue";
import Jira from "./views/integration/jira/Jira.vue";
import GlobalSettings from "./views/system/GlobalSettings.vue";
import DatabaseState from "./views/system/DatabaseState.vue";
import ClientDashboard from "./views/clientDashboard/ClientDashboard.vue";
import PaymentHistory from "./views/clientDashboard/PaymentHistory.vue";
import Packages from "./views/clientDashboard/Packages/Packages.vue";
import ClientWorklogReport from "./views/clientDashboard/reports/ClientWorklogReport.vue";
import ClientBalance from "./views/clientDashboard/reports/ClientBalance.vue";
import Login from "./views/system/login/Login.vue";
import Specifications from "@/views/operations/specifications/Specifications.vue";
import Specification from "@/views/operations/specifications/Specification.vue";
import EmployeesGradesReport from "./views/reports/employees-grades/EmployeesGradesReport.vue";
import GenDocBlocks from "./GenDoc/views/document-blocks/DocumentBlocks.vue";
import GenDocBlock from "./GenDoc/views/document-blocks/DocumentBlock.vue";
import GenDocDocuments from "./GenDoc/views/documents/Documents.vue";
import GenDocDocument from "./GenDoc/views/documents/Document.vue";
import GenDocImport from "./GenDoc/views/import/Import.vue";
import Departments from "./views/catalogs/departments/Departments.vue";
import Department from "./views/catalogs/departments/Department.vue";
import ClientSpecifications from "./views/clientDashboard/specifications/ClientSpecifications.vue";
import ClientSpecification from "./views/clientDashboard/specifications/ClientSpecification.vue";
import ProjectsIssues from "./projects/views/issues/Issues.vue";
import ProjectsIssue from "./projects/views/issues/Issue.vue";
import ProjectsProjects from "./projects/views/projects/Projects.vue";
import ProjectsProject from "./projects/views/projects/Project.vue";
import CrmEmpolyees from "./Crm/views/employees/Employees.vue";
import CrmEmpolyee from "./Crm/views/employees/Employee.vue";
import CrmTasks from "./Crm/views/tasks/Tasks.vue";
import CrmTask from "./Crm/views/tasks/Task.vue";
import CrmCompanies from "./Crm/views/companies/Companies.vue";
import CrmCompany from "./Crm/views/companies/Company.vue";
import CrmContacts from "./Crm/views/contacts/Contacts.vue";
import CrmContact from "./Crm/views/contacts/Contact.vue";
import CrmCurrencies from "./Crm/views/currencies/Currencies.vue";
import CrmCurrency from "./Crm/views/currencies/Currency.vue";
import CrmAgreements from "./Crm/views/agreements/Agreements.vue";
import CrmAgreement from "./Crm/views/agreements/Agreement.vue";
import CrmSalesFunnelTypes from "./Crm/views/salesFunnelTypes/SalesFunnelTypes.vue";
import CrmSalesFunnelType from "./Crm/views/salesFunnelTypes/SalesFunnelType.vue";
import CrmSalesFunnelStages from "./Crm/views/salesFunnelStages/SalesFunnelStages.vue";
import CrmSalesFunnelStage from "./Crm/views/salesFunnelStages/SalesFunnelStage.vue";
import SalesUnits from "./sales/views/units/Units.vue";
import SalesUnit from "./sales/views/units/Unit.vue";
import SalesClients from "./sales/views/clients/Clients.vue";
import SalesClient from "./sales/views/clients/Client.vue";
import SalesProducts from "./sales/views/products/Products.vue";
import SalesProduct from "./sales/views/products/Product.vue";
import SalesProductReceipts from "./sales/views/productReceipts/ProductReceipts.vue";
import SalesProductReceipt from "./sales/views/productReceipts/ProductReceipt.vue";
import SalesProductСonsumptions from "./sales/views/productConsumption/ProductConsumptions.vue";
import SalesProductСonsumption from "./sales/views/productConsumption/ProductConsumption.vue";

import JsonDealerExchangeEntries from "./json-dealer-module/views/ExchangeEntries.vue";

import auth from "@/auth";

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "main",
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
          auth.roles.ACCOUNT_CLIENT,
        ],
      },
      component: {
        render: (h) => {
          switch (auth.getRole()) {
            case 4:
              return h(ClientDashboard);
            default:
              return h("");
          }
        },
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "Авторизація",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
          auth.roles.ACCOUNT_CLIENT,
        ],
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: ClientDashboard,
      meta: {
        title: "Головна",
        permissions: [auth.roles.ADMINISTRATOR, auth.roles.ACCOUNT_CLIENT],
      },
    },
    {
      path: "/employees",
      name: "employees",
      component: Employees,
      meta: {
        title: "Виконавці",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/employees/:id",
      name: "employee",
      component: Employee,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/worklog",
      name: "worklog",
      component: {
        render: (h) => {
          switch (auth.getRole()) {
            case 4:
              return h(ClientWorklogReport);
            default:
              return h(WorklogReport);
          }
        },
      },
      meta: {
        title: "Звіт по роботах",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
          auth.roles.ACCOUNT_CLIENT,
        ],
      },
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: {
        title: "Користувачі",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/users/:id",
      name: "user",
      component: User,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/clients",
      name: "clients",
      component: Clients,
      meta: {
        title: "Клієнти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/clients/:id",
      name: "client",
      component: Client,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/managers",
      name: "managers",
      component: Managers,
      meta: {
        title: "Менеджери",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/managers/:id",
      name: "manager",
      component: Manager,
      props: true,
      meta: {
        title: "Клієнти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payments",
      name: "payments",
      component: Payments,
      meta: {
        title: "Оплати",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payments/:id",
      name: "payment",
      component: Payment,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/specifications",
      name: "specifications",
      component: Specifications,
      meta: {
        title: "Специфікації",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/specifications/:id",
      name: "specification",
      component: Specification,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/clientSpecifications",
      name: "clientSpecifications",
      component: ClientSpecifications,
      meta: {
        title: "Специфікації",
        permissions: [auth.roles.ACCOUNT_CLIENT],
      },
    },
    {
      path: "/clientSpecifications/:id",
      name: "clientSpecification",
      component: ClientSpecification,
      props: true,
      meta: {
        permissions: [auth.roles.ACCOUNT_CLIENT],
      },
    },
    {
      path: "/bonuses",
      name: "bonuses",
      component: Bonuses,
      meta: {
        title: "Бонуси",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/bonuses/:id",
      name: "bonus",
      component: Bonus,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/invoices",
      name: "invoices",
      component: Invoices,
      meta: {
        title: "Рахунки на сплату",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/invoices/:id",
      name: "invoice",
      component: Invoice,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/client-balance-report",
      name: "balance",
      component: {
        render: (h) => {
          switch (auth.getRole()) {
            case 4:
              return h(ClientBalance);
            default:
              return h(Balance);
          }
        },
      },
      meta: {
        title: "Баланс (за Пакетами)",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
          auth.roles.ACCOUNT_CLIENT,
        ],
      },
    },
    {
      path: "/debt",
      name: "debt",
      component: Debt,
      meta: {
        title: "Заборгованість",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payment-packages",
      name: "paymentPackages",
      component: PaymentPackages,
      meta: {
        title: "Пакети Cплати",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payment-packages/:id",
      name: "paymentPackage",
      component: PaymentPackage,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/services",
      name: "services",
      component: Services,
      meta: {
        title: "Сервіси",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/services/:id",
      name: "service",
      component: Service,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/products",
      name: "products",
      component: Products,
      meta: {
        title: "Продукти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/products/:id",
      name: "product",
      component: Product,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
      meta: {
        title: "Проекти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects/:id",
      name: "project",
      component: Project,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/service-types",
      name: "serviceTypes",
      component: ServiceTypes,
      meta: {
        title: "Типи Сервісів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/service-types/:id",
      name: "serviceType",
      component: ServiceType,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/services-to-prolongation",
      name: "servicesToProlongation",
      component: ServicesToProlongation,
      meta: {
        title: "Сервіси до подовження",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/packages-to-prolongation",
      name: "packagesToProlongation",
      component: PackagesToProlongation,
      meta: {
        title: "Пакети до подовження v2",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/packages-to-prolongation-old",
      name: "packagesToProlongationOld",
      component: PackagesToProlongationOld,
      meta: {
        title: "Пакети до подовження",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payment-sources",
      name: "paymentSources",
      component: PaymentSources,
      meta: {
        title: "Джерела Коштів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payment-sources/:id",
      name: "paymentSource",
      component: PaymentSource,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payers",
      name: "payers",
      component: Payers,
      meta: {
        title: "Платники",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payers/:id",
      name: "payer",
      component: Payer,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/product-categories",
      name: "productCategories",
      component: ProductCategories,
      meta: {
        title: "Категорії продуктів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/product-categories/:id",
      name: "productCategory",
      component: ProductCategory,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-by-payments",
      name: "salesByPayments",
      component: SalesByPayments,
      meta: {
        title: "Продажі (по оплатах)",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/managers-bonuses",
      name: "managersBonuses",
      component: ManagersBonuses,
      meta: {
        title: "Бонуси менеджерів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/worklog-summary",
      name: "worklogSummary",
      component: WorklogSummary,
      meta: {
        title: "Загальний звіт по роботах",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/privat24",
      name: "privat24",
      component: Privat24,
      meta: {
        title: "Приват24",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/taskombank",
      name: "taskombank",
      component: Taskombank,
      meta: {
        title: "Таскомбанк",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/jira",
      name: "jira",
      component: Jira,
      meta: {
        title: "Jira",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: GlobalSettings,
      meta: {
        title: "Налаштування",
        permissions: [auth.roles.ADMINISTRATOR],
      },
    },
    {
      path: "/database-state",
      name: "databaseState",
      component: DatabaseState,
      meta: {
        title: "Стан бази даних",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/payment-history",
      name: "paymentHistory",
      component: PaymentHistory,
      meta: {
        title: "Історія рахунків та оплат",
        permissions: [auth.roles.ACCOUNT_CLIENT],
      },
    },
    {
      path: "/payment-packages",
      name: "PaymentPackages",
      component: Packages,
      meta: {
        title: "Пакети Cплати",
        permissions: [auth.roles.ACCOUNT_CLIENT],
      },
    },
    {
      path: "/employees-grades",
      name: "employeesGrades",
      component: EmployeesGradesReport,
      meta: {
        title: "Звіт по роботах",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/gen-doc-blocks",
      name: "genDocBlocks",
      component: GenDocBlocks,
      meta: {
        title: "Блоки",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/gen-doc-blocks/:id",
      name: "genDocBlock",
      component: GenDocBlock,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/gen-doc-documents",
      name: "genDocDocuments",
      component: GenDocDocuments,
      meta: {
        title: "Документы",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/gen-doc-documents/:id",
      name: "genDocDocument",
      component: GenDocDocument,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/gen-doc-import",
      name: "genDocImport",
      component: GenDocImport,
      meta: {
        title: "Імпорт",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/departments",
      name: "departments",
      component: Departments,
      meta: {
        title: "Департаменти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/departments/:id",
      name: "department",
      component: Department,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects-issues",
      name: "projectsIssues",
      component: ProjectsIssues,
      meta: {
        title: "Задачи",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects-issues/:id",
      name: "projectsIssue",
      component: ProjectsIssue,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects-projects",
      name: "projectsProjects",
      component: ProjectsProjects,
      meta: {
        title: "Проекти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/projects-projects/:id",
      name: "projectsProject",
      component: ProjectsProject,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-employees",
      name: "crmEmployees",
      component: CrmEmpolyees,
      meta: {
        title: "Співробітники",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-employees/:id",
      name: "crmEmployee",
      component: CrmEmpolyee,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-tasks",
      name: "crmTasks",
      component: CrmTasks,
      meta: {
        title: "Завдання",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-tasks/:id",
      name: "crmTask",
      component: CrmTask,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-companies",
      name: "crmCompanies",
      component: CrmCompanies,
      meta: {
        title: "Компанії",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-companies/:id",
      name: "crmCompany",
      component: CrmCompany,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-contacts",
      name: "crmContacts",
      component: CrmContacts,
      meta: {
        title: "Контакти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-contacts/:id",
      name: "crmContact",
      component: CrmContact,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-currencies",
      name: "crmCurrencies",
      component: CrmCurrencies,
      meta: {
        title: "Валюти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-currencies/:id",
      name: "crmCurrency",
      component: CrmCurrency,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-agreements",
      name: "crmAgreements",
      component: CrmAgreements,
      meta: {
        title: "Угоди",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-agreements/:id",
      name: "crmAgreement",
      component: CrmAgreement,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-sales-funnel-types",
      name: "crmSalesFunnelTypes",
      component: CrmSalesFunnelTypes,
      meta: {
        title: "Типи воронок продажів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-sales-funnel-types/:id",
      name: "crmSalesFunnelType",
      component: CrmSalesFunnelType,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-sales-funnel-stages",
      name: "crmSalesFunnelStages",
      component: CrmSalesFunnelStages,
      meta: {
        title: "Стадії воронок продажів",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/crm-sales-funnel-stages/:id",
      name: "crmSalesFunnelStage",
      component: CrmSalesFunnelStage,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-units",
      name: "salesUnits",
      component: SalesUnits,
      meta: {
        title: "Одиниці виміру",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-units/:id",
      name: "salesUnit",
      component: SalesUnit,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-clients",
      name: "salesClients",
      component: SalesClients,
      meta: {
        title: "Контрагенти",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-clients/:id",
      name: "salesClient",
      component: SalesClient,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-products",
      name: "salesProducts",
      component: SalesProducts,
      meta: {
        title: "Товари та матеріали, Послуги",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/sales-products/:id",
      name: "salesProduct",
      component: SalesProduct,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/json-dealer/exchange-entries",
      name: "jsonDialerExchangeEntires",
      component: JsonDealerExchangeEntries,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
        ],
      },
    },
    {
      path: "/product-receipts",
      name: "productReceipts",
      component: SalesProductReceipts,
      meta: {
        title: "Приход товару",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/product-receipts/:id",
      name: "productReceipt",
      component: SalesProductReceipt,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/product-consumptions",
      name: "productСonsumptions",
      component: SalesProductСonsumptions,
      meta: {
        title: "Витрата товару",
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
    {
      path: "/product-consumptions/:id",
      name: "productСonsumption",
      component: SalesProductСonsumption,
      props: true,
      meta: {
        permissions: [
          auth.roles.ADMINISTRATOR,
          auth.roles.USER,
          auth.roles.SALES_MANAGER,
          auth.roles.ACCOUNT_MANAGER,
        ],
      },
    },
  ],
});
